export default "__VITE_ASSET__BfShAssQ__"